import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LibModule } from '../lib/lib.module';
import { HomeComponent } from './home/home.component';
import { SettingComponent } from './setting/setting.component';
import { BanktransferComponent } from './banktransfer/banktransfer.component';
import { UserComponent } from './user/user.component';
import { AccuseComponent } from './accuse/accuse.component';
import { AppinfoComponent } from './appinfo/appinfo.component';
import { AppconfigComponent } from './appconfig/appconfig.component';
import { CheckinfoComponent } from './checkinfo/checkinfo.component';
import { ProfileComponent } from './profile/profile.component';
import { FormsModule,ReactiveFormsModule  } from '@angular/forms';
import { LightboxComponent } from './../layout/lightbox/lightbox.component';
import { PagnationComponent } from './../layout/pagnation/pagnation.component';
import { PagnationoutComponent } from './../layout/pagnationout/pagnationout.component';
import { UserinfoComponent } from './../layout/userinfo/userinfo.component';
import { RtableComponent } from './../layout/rtable/rtable.component';
import { SpinnerComponent } from './../layout/spinner/spinner.component';
import { ToastComponent } from './../layout/toast/toast.component';
import { ImgComponent } from './../layout/img/img.component';
import { CheckswitchComponent } from './../layout/checkswitch/checkswitch.component';
import { ImgCropperComponent } from './../layout/img-cropper/img-cropper.component';
import { ModalcontentComponent } from './../layout/modalcontent/modalcontent.component';
import { UserandactiveComponent } from './../layout/userandactive/userandactive.component';
import { CheckPermissionsComponent } from './../layout/check-permissions/check-permissions.component';
import { MonthPickerComponent } from './../layout/month-picker/month-picker.component';

import { DateComponent } from './../layout/date/date.component';

import { HighchartsChartModule } from 'highcharts-angular';
import { WithdrawrecordComponent } from './withdrawrecord/withdrawrecord.component';
import { RanklistComponent } from './ranklist/ranklist.component';
import { AnnouncementComponent } from './announcement/announcement.component';
import { BlacklistComponent } from './blacklist/blacklist.component';
import { AgentbonusComponent } from './agentbonus/agentbonus.component';
import { AgentsetingComponent } from './agentseting/agentseting.component';
import { OtagentsetingComponent } from './otagentseting/otagentseting.component';
import { GmComponent } from './gm/gm.component';
import { GametopicComponent } from './gametopic/gametopic.component';
import { ChattemplateComponent } from './chattemplate/chattemplate.component';
import { PushlistComponent } from './pushlist/pushlist.component';
import { UseractiveComponent } from './useractive/useractive.component';
import { RewardofficalComponent } from './rewardoffical/rewardoffical.component';

import { AgentmemberComponent } from './agentmember/agentmember.component';
import { ShortlinkComponent } from './shortlink/shortlink.component';
import { SyssettingComponent } from './syssetting/syssetting.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { TradelistComponent } from './tradelist/tradelist.component';
import { ActiveComponent } from './active/active.component';
import { PassinfoComponent } from './passinfo/passinfo.component';
import { StatisticsComponent } from './statistics/statistics.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatInputModule } from '@angular/material/input';
// MatDialogModule/MatTableModule/MatSortModule 已移至 ot-agent-shared.module（僅 agent 群使用，改隨 lazy chunk 載入）
import { MassSendingComponent } from './masssending/masssending.component';
import { Community_sysComponent } from './community_sys/community_sys.component';
import { UserlvComponent } from './userlv/userlv.component';
import { ManualtitleComponent } from './manualtitle/manualtitle.component';
import { LiveComponent } from './live/live.component';
import { ReferralComponent } from './referral/referral.component';
import { StorywallComponent } from './storywall/storywall.component';
import { StableComponent } from './stable/stable.component';
import { MsgreturnComponent } from './msgreturn/msgreturn.component';
import { FindsthComponent } from './findsth/findsth.component';
import { StoryactiveComponent } from './storyactive/storyactive.component';
import { VoicelistComponent } from './voicelist/voicelist.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { CustomervalueComponent } from './customervalue/customervalue.component';
import { TableComponent } from './../layout/table/table.component';
import { DynamicFormatPipe } from './../dynamic-format.pipe';
import { AdminreviewComponent } from './adminreview/adminreview.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { TableV2Component } from '../layout/table-v2/table-v2.component';
import { TableV2OtComponent } from '../layout/table-v2-ot/table-v2-ot.component';
import { SearchComponent } from '../layout/search/search.component';
import { PushmessageComponent } from '../layout/pushmessage/pushmessage.component';

import { StatisticesComponent } from './statistices/statistices.component';
import { MatDatepickerModule } from "@angular/material/datepicker";
import {MatNativeDateModule} from '@angular/material/core';
import { UserRelationshipComponent } from './user-relationship/user-relationship.component';
import { TagsystemComponent } from './tagsystem/tagsystem.component';
import { CalendarComponent } from '../layout/calendar/calendar.component';
import { PromotionRecordComponent } from './promotion-record/promotion-record.component';
import { NewPushlistComponent } from './new-pushlist/new-pushlist.component';
import { TagselectComponent } from '../layout/tagselect/tagselect.component';
import { LotteryComponent } from './lottery/lottery.component';
import { FakeComponent } from './fake/fake.component';
import { SmsRecodeComponent } from './sms-recode/sms-recode.component';
import { BenefitsComponent } from './benefits/benefits.component';
// zego 系列已改為 lazy module（zego*/*.lazy.module.ts）
// agent 群（otagentmember/ot-agentfamily/otagentmemberbymobile + 其 dialog）已改為 lazy module（見 ot-agent-shared.module.ts）
import { LogviewComponent } from './logview/logview.component';
import { JsonViewerComponent } from '../layout/json-viewer/json-viewer.component';
import { SudgameComponent } from './sudgame/sudgame.component';
import { UserPermissionComponent } from './user-permission/user-permission.component';
import { GiftComponent } from './gift/gift.component';
import { BagitemComponent } from './bagitem/bagitem.component';
import { SharedModule } from '../shared/shared.module';
import { MemberUplineComponent } from './member-upline/member-upline.component';
import { VideoComponent } from './video/video.component';
import { HighRiskChurnComponent } from './high-risk-churn/high-risk-churn.component';
import { UserBehaviorComponent } from './user-behavior/user-behavior.component';
import { StudioMemberComponent } from './studio-member/studio-member.component';





@NgModule({
  declarations: [ StudioMemberComponent, UserBehaviorComponent, HighRiskChurnComponent, JsonViewerComponent, LogviewComponent, NewPushlistComponent,HomeComponent,SettingComponent,BanktransferComponent,SmsRecodeComponent,TableComponent,DynamicFormatPipe,TableV2OtComponent,TableV2Component,TagselectComponent, SearchComponent,PushmessageComponent,MonthPickerComponent,
    UserComponent,AccuseComponent,AppinfoComponent,AppconfigComponent,CheckinfoComponent,ProfileComponent,UserRelationshipComponent,TagsystemComponent,CalendarComponent,PromotionRecordComponent,SudgameComponent,UserPermissionComponent,
    LightboxComponent,PagnationComponent,PagnationoutComponent,UserinfoComponent,ImgComponent,CheckswitchComponent,DateComponent,ModalcontentComponent,CheckPermissionsComponent,ImgCropperComponent,UserandactiveComponent,
     WithdrawrecordComponent, RanklistComponent, AnnouncementComponent, BlacklistComponent, AgentbonusComponent, GiftComponent,VideoComponent,
     AgentsetingComponent,OtagentsetingComponent, GmComponent, GametopicComponent, ChattemplateComponent, PushlistComponent, UseractiveComponent, LotteryComponent,FakeComponent,BenefitsComponent,
      RewardofficalComponent,  AgentmemberComponent, ShortlinkComponent,SyssettingComponent, TradelistComponent, RtableComponent, ActiveComponent, PassinfoComponent,StatisticesComponent, StatisticsComponent, MassSendingComponent, Community_sysComponent,UserlvComponent, ManualtitleComponent, LiveComponent, ReferralComponent, StorywallComponent, StableComponent, MsgreturnComponent, FindsthComponent, StoryactiveComponent, VoicelistComponent, CustomervalueComponent, AdminreviewComponent, MemberUplineComponent, BagitemComponent ],
  imports: [
	SharedModule,CommonModule,FormsModule,HighchartsChartModule,LibModule,FormsModule,DragDropModule,MatDatepickerModule,MatNativeDateModule,
    ReactiveFormsModule,NgxDaterangepickerMd.forRoot(),MatStepperModule,MatInputModule,ImageCropperModule,MatOptionModule,MatSelectModule
  ],
  exports: [
    FormsModule,LightboxComponent,UserinfoComponent,DragDropModule,
    PagnationComponent,PagnationoutComponent,SpinnerComponent,ToastComponent,RtableComponent,ImgComponent,CheckswitchComponent,DateComponent,ModalcontentComponent,ImgCropperComponent,CheckPermissionsComponent,UserandactiveComponent,TableV2Component,TableV2OtComponent,MonthPickerComponent
  ]
})

export class CommModule { }
